var AbExitPopup = new function() {
    var $ = jQuery;

    /**
     * Initialize the popup
     */
    this.initialize = function() {
        // Load modal content through AJAX
        $.ajax({
            method:   'GET',
            url:      _ab.ajaxUrl + '?action=exitIntentModal',
            data:     {
                popup: window.AbExitPopUpSettings.popup
            },
            complete: function(data) {
                var $exitModal = $('#modal-exit-intent');
                $exitModal.html(data.responseText);
                $exitModal.trigger('init-container');
                $exitModal.modal({
                    show: false
                })
            },
        });

        var event = function event(e) {
            var windowWidth = $(window).width();
            // User leaves the screen on the top right or top left
            if (e.clientY < 5) {
                if (e.clientX > (windowWidth - (windowWidth * 0.2)) || e.clientX < (windowWidth * 0.2)) {
                    AbExitPopup.show();
                    // Popup only appears once
                    $(document).off('mouseleave', event);
                }
            }
        };

        $(document).on('mouseleave', event);
    };

    /**
     * Show the popup
     */
    this.show = function() {
        var $exitModal = $('#modal-exit-intent');
        $exitModal.modal('show');
    };

    /**
     * Hide the popup
     */
    this.hide = function() {
        var $exitModal = $('#modal-exit-intent');
        $exitModal.modal('hide');
    };
};

jQuery(document).ready(function() {
    AbExitPopup.initialize();
});
